var React = require('react');
var StatsTable = require('./StatsTable.jsx');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');

var Circles = React.createClass({
    getCircles: function(count, home, filled){
        var circles = [];
        var colors = this.props.colors || ["#ffc300", "#d31346"];
        var circleStyle = filled ? {"backgroundColor": home ? colors[0] : colors[1]} : null;
        
        for (var i = 0; i < count; i++) {
            circles.push(
                <span key={(filled ? 'cw.' : 'cl.')+i} className="circle countIcon filled" style={circleStyle}></span>
            );
        }
        
        return circles;
    },
    render: function(){
        
        var filledCircles = this.getCircles(this.props.won, this.props.home, true);
        var emptyCircles = this.getCircles(this.props.lost, this.props.home, false);
        
        return (
            <div className="countIcons">
                {filledCircles.concat(emptyCircles)}
            </div>
        );
    }
});

var SetPieces = React.createClass({
    getCircles : function(count, home, filled){
        var circles = [];
        var circleStyle = filled ? {"backgroundColor": home ? "#ffc300" : "#d31346"} : null;
        
        for (var i = 0; i < count; i++) {
            circles.push(
                <span key={(filled ? 'cw.' : 'cl.')+i} className="circle countIcon filled" style={circleStyle}></span>
            );
        }
        
        return circles;
    },
    render : function(){
        
        var scrumPieces = this.props.scrumPieces;
        var lineOutsPieces = this.props.lineOutsPieces;
        var homeScrumPercent = Math.round(scrumPieces.home.percent);
        var awayScrumPercent = Math.round(scrumPieces.away.percent);
        var homeLineOutsPercent = Math.round(lineOutsPieces.home.percent);
        var awayhomeLineOutsPercent = Math.round(lineOutsPieces.away.percent);
        
        homeScrumPercent = isNaN(homeScrumPercent) ? 0 : homeScrumPercent; 
        awayScrumPercent = isNaN(awayScrumPercent) ? 0 : awayScrumPercent; 
        
        homeLineOutsPercent = isNaN(homeLineOutsPercent) ? 0 : homeLineOutsPercent; 
        awayhomeLineOutsPercent = isNaN(awayhomeLineOutsPercent) ? 0 : awayhomeLineOutsPercent; 
        
        return (
            <article className="sub-module equal-height countChartList height-reset" style={{"height":"317px"}}>
				<header className="bordered"><h1>Set Pieces</h1></header>
				<div className="content">
								
                    <TeamCompareHeader heading="Own scrums won" home={this.props.home} away={this.props.away} />
                    
                    <div className="countChart">
                        <div className="home">
                            <div className="countLabel">{(scrumPieces.home.won) + "/" + scrumPieces.home.total} <span className="percentage">{"(" + homeScrumPercent + "%)"}</span></div>
                            <Circles colors={this.props.colors} won={scrumPieces.home.won} lost={scrumPieces.home.total - scrumPieces.home.won} home={true} />
                        </div>
                        
                        <div className="away">
                            <div className="countLabel">
                                <span className="percentage">{"(" + awayScrumPercent + "%)"}</span>{" " + (scrumPieces.away.won) + "/" + scrumPieces.away.total}
                            </div>
                            <Circles colors={this.props.colors} won={scrumPieces.away.won} lost={scrumPieces.away.total - scrumPieces.away.won} home={false} />
                        </div>
                    </div>
        		</div>

                <div className="content">
                    <div className="teamCompareHeaderWrap ">
                    	<div className="teamCompareHeader">
                    		<div className="team team1"></div>
                    		<div className="header">Own Lineouts Won</div>
                    		<div className="team team2"></div>
                    	</div>
                    </div>
                    <div className="countChart">
                        <div className="home">
                            <div className="countLabel">
                                {(lineOutsPieces.home.won) + "/" + lineOutsPieces.home.total} <span className="percentage">{"(" + homeLineOutsPercent + "%)"}</span>
                            </div>
                            <Circles colors={this.props.colors} won={lineOutsPieces.home.won} lost={lineOutsPieces.home.total - lineOutsPieces.home.won} home={true} />
                        </div>

                        <div className="away">
                            <div className="countLabel">
                                <span className="percentage">{"(" + awayhomeLineOutsPercent + "%)"}</span>{" " + (lineOutsPieces.away.won) + "/" + lineOutsPieces.away.total}
                            </div>
                            <Circles colors={this.props.colors} won={lineOutsPieces.away.won} lost={lineOutsPieces.away.total - lineOutsPieces.away.won} home={false} />
                        </div>
                    </div>
                </div>
			</article>
        );
    }
});

module.exports = SetPieces;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/SetPieces.jsx
 **/